import { matchRoutes, type RouteObject } from "react-router";

/**
 * Returns the route template matched by `pathname` (e.g. `/employees/:id`),
 * never the real URL: ids and query strings must not leave the browser.
 */
export const getRoutePattern = (routes: RouteObject[], pathname: string): string | null => {
  const matches = matchRoutes(routes, pathname);
  if (!matches) return null;
  const pattern = matches.reduce((path, { route }) => {
    if (!route.path) return path;
    return route.path.startsWith("/") ? route.path : `${path}/${route.path}`;
  }, "");
  return pattern.replace(/\/+/g, "/").replace(/(.)\/$/, "$1") || "/";
};
